import React from 'react';
import "./navbar.css";
import { motion, AnimatePresence } from "framer-motion";
import { NavLink } from 'react-router-dom';
import NAV_LINKS, { isExact } from '../../../../Utils/navLinks';

const modal = {
  hidden: {
    x: "15vh",
    opacity: 0 
  }, 
  visible: {
    x: 0,
    opacity: 1, 
    transition: { 
      type: "tween",
      ease: "easeOut", 
      duration: 0.2,
    }
  },
  exit: {
    x: "10vh",
    opacity: 0,
    transition: { 
      type: "tween",
      ease: "easeOut", 
      duration: 0.15,
    }
  }
}

const backdrop = { 
  visible: {opacity: 1},
  hidden: {
    opacity: 0,
    transition: {duration: 0}
  }
}

/* the same six destinations as the bar, stacked - a click on any of them
   bubbles up to the backdrop, which is what closes the menu */
const NavBar = ({ openMenu, setOpenMenu }) => {
  return (
    <AnimatePresence>
      {openMenu &&
        (<motion.div className='nav-bar'
          variants={backdrop}
          initial="hidden"
          animate="visible"
          onClick={() => setOpenMenu(false)}
        >
          <motion.div className="links fcc"
            variants={modal}
            initial="hidden"
            animate="visible"
            exit='exit'
          >
            {
              NAV_LINKS.map(({ to, label }) => (
                <NavLink className="link" to={to} end={isExact(to)} key={to}>{label}</NavLink>
              ))
            }
          </motion.div>
        </motion.div>)}
    </AnimatePresence>
  )
}

export default NavBar
